import { gql } from "@apollo/client";

export const GET_DEMOGRAPHIC_QUESTIONS = gql`
  query GetDemographicQuestions {
    getDemographicQuestions {
      id
      questionText
      questionType
      isRequired
      orderIndex
      answerOptions {
        id
        text
        value
        orderIndex
      }
    }
  }
`;

export const GET_DEMOGRAPHIC_RESPONSES = gql`
  query GetDemographicResponses($sessionId: String!) {
    getDemographicResponses(sessionId: $sessionId) {
      id
      questionId
      textValue
      numberValue
      selectedOptionIds
    }
  }
`;
